import { AppPage } from '@launchpad';
import React from 'react';
import { AuthorisationImportFileTable } from '../components/AuthorisationImportFileTable';

const AuthorisationImportDashboard: React.FC = () => {
  return (
    <AppPage title="Authorisation Import dashboard" icon="list">
      <div className="row">
        <div className="col-sm-12">
          <AuthorisationImportFileTable />
        </div>
      </div>
    </AppPage>
  );
};

export default AuthorisationImportDashboard;
